module.exports = __webpack_public_path__ + "build/desktop/img/calendar.8a89ee0f44ad58920db125198046df58.svg";